/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50765Req {
  
  /** 任务id */
  taskId?: number;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：TaskStatusEnum,<pre> */
  taskStatus?: number;
};



export interface API50765Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50765 更改状态

export interface IUsePostAPI50765Return {
  /** 更改状态: 接口请求状态 */
  isAPI50765Loading: boolean;
  /** 更改状态: 接口请求返回数据 */
  dataAPI50765: API50765Res;
  /**  更改状态: 接口数据请求方法 */
  fetchAPI50765Data:  (inputs: API50765Req, config?: YWRequestConfig) => Promise<API50765Res>;
  /** 更改状态: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50765 = ():IUsePostAPI50765Return => {
  let isMount = true;
  const [isAPI50765Loading, setIsAPI50765Loading] = useState(false);
  const [dataAPI50765, setDataAPI50765] = useState<API50765Res>({} as API50765Res);
  const requestUrl = `${basePath}/team-work/workTask/updateStatus`;

  const fetchAPI50765Data = async (inputs: API50765Req, config?: YWRequestConfig): Promise<API50765Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50765Req>) || {}) as API50765Req;
    
  
    if ( isMount ) {
      setIsAPI50765Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50765Res>(`${basePath}/team-work/workTask/updateStatus`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50765(res || {} as API50765Res);
        setIsAPI50765Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50765Loading(false);
      }
      return false as unknown as API50765Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50765Loading,
    dataAPI50765,
    fetchAPI50765Data,
    requestUrl,
  }
}

